import React from "react"

export function Bell(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="13"
      height="14"
      viewBox="0 0 13 14"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_324_5076)">
        <path
          d="M6.12448 0C5.64049 0 5.24948 0.391016 5.24948 0.875V1.4C3.25338 1.80469 1.74948 3.57109 1.74948 5.6875V6.20156C1.74948 7.48672 1.27643 8.72812 0.423305 9.69063L0.220961 9.91758C-0.00872652 10.1746 -0.063414 10.5437 0.0760391 10.8582C0.215492 11.1727 0.529945 11.375 0.874477 11.375H11.3745C11.719 11.375 12.0307 11.1727 12.1729 10.8582C12.3151 10.5437 12.2577 10.1746 12.028 9.91758L11.8256 9.69063C10.9725 8.72812 10.4995 7.48945 10.4995 6.20156V5.6875C10.4995 3.57109 8.99557 1.80469 6.99948 1.4V0.875C6.99948 0.391016 6.60846 0 6.12448 0ZM7.36315 13.4887C7.69127 13.1605 7.87448 12.7148 7.87448 12.25H6.12448H4.37448C4.37448 12.7148 4.55768 13.1605 4.8858 13.4887C5.21393 13.8168 5.65963 14 6.12448 14C6.58932 14 7.03502 13.8168 7.36315 13.4887Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_324_5076">
          <path d="M0 0H12.25V14H0V0Z" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
